import React from 'react';
import { Container, Row, Col, Card } from 'react-bootstrap';
import Header from './header';
import Footer from './footer';

class TermsAndConditions extends React.Component {
  render() {
    const sectionStyle = {
      marginBottom: '30px',
      paddingBottom: '22px',
      borderBottom: '1px solid #eef1f5',
    };

    const headingStyle = {
      fontSize: '20px',
      fontWeight: '700',
      color: '#172033',
      marginBottom: '10px',
      lineHeight: '1.4',
    };

    const paragraphStyle = {
      fontSize: '15px',
      lineHeight: '1.8',
      color: '#667085',
      marginBottom: '0',
    };

    return (
      <div
        id="termsandconditions"
        style={{
          background: '#f6f8fc',
          minHeight: '100vh',
          paddingBottom: '0',
        }}
      >
        <Header />

        {/* Page Hero */}
        <div
          style={{
            background:
              'linear-gradient(135deg, #0d6efd 0%, #084298 100%)',
            padding: '55px 20px 65px',
            color: '#fff',
            textAlign: 'center',
          }}
        >
          <Container>
            <div
              style={{
                maxWidth: '800px',
                margin: '0 auto',
              }}
            >
              <div
                style={{
                  display: 'inline-flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  width: '58px',
                  height: '58px',
                  borderRadius: '16px',
                  background: 'rgba(255,255,255,0.15)',
                  fontSize: '27px',
                  marginBottom: '18px',
                }}
              >
                §
              </div>

              <h1
                style={{
                  fontSize: 'clamp(32px, 5vw, 48px)',
                  fontWeight: '800',
                  marginBottom: '12px',
                  letterSpacing: '-0.5px',
                }}
              >
                Terms and Conditions
              </h1>

              <p
                style={{
                  margin: 0,
                  fontSize: '16px',
                  lineHeight: '1.7',
                  opacity: 0.9,
                }}
              >
                Please read these terms carefully before using ErwaToday.in.
              </p>
            </div>
          </Container>
        </div>

        <Container
          style={{
            marginTop: '-30px',
            position: 'relative',
            zIndex: 2,
            paddingBottom: '50px',
          }}
        >
          {/* Main Terms Card */}
          <Row>
            <Col md={10} lg={9} className="mx-auto">
              <Card
                style={{
                  border: 'none',
                  borderRadius: '18px',
                  boxShadow: '0 12px 40px rgba(16, 24, 40, 0.08)',
                  overflow: 'hidden',
                }}
              >
                <Card.Body
                  style={{
                    padding: 'clamp(25px, 5vw, 50px)',
                  }}
                >
                  {/* Card Header */}
                  <div
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      gap: '14px',
                      marginBottom: '35px',
                      paddingBottom: '22px',
                      borderBottom: '2px solid #f0f2f5',
                    }}
                  >
                    <div
                      style={{
                        width: '46px',
                        height: '46px',
                        borderRadius: '12px',
                        background: '#eaf2ff',
                        color: '#0d6efd',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        fontSize: '20px',
                        fontWeight: '800',
                        flexShrink: 0,
                      }}
                    >
                      01
                    </div>

                    <div>
                      <h2
                        style={{
                          fontSize: '24px',
                          fontWeight: '750',
                          color: '#172033',
                          margin: 0,
                        }}
                      >
                        General Terms
                      </h2>

                      <p
                        style={{
                          margin: '4px 0 0',
                          color: '#98a2b3',
                          fontSize: '14px',
                        }}
                      >
                        Terms governing the use of our website
                      </p>
                    </div>
                  </div>

                  {/* Section 1 */}
                  <div style={sectionStyle}>
                    <h3 style={headingStyle}>
                      1. Intellectual Property Rights
                    </h3>

                    <p style={paragraphStyle}>
                      The content and materials on this website, including text,
                      graphics, logos, images, and software, are the property of
                      ErwaToday.in and are protected by copyright laws.
                    </p>
                  </div>

                  {/* Section 2 */}
                  <div style={sectionStyle}>
                    <h3 style={headingStyle}>
                      2. Use of the Website
                    </h3>

                    <p style={paragraphStyle}>
                      This website may only be used for lawful purposes and in
                      accordance with these terms.
                    </p>
                  </div>

                  {/* Section 3 */}
                  <div style={sectionStyle}>
                    <h3 style={headingStyle}>
                      3. User Content
                    </h3>

                    <p style={paragraphStyle}>
                      Any content submitted through this website will be
                      considered non-confidential and non-proprietary.
                    </p>
                  </div>

                  {/* Section 4 */}
                  <div style={sectionStyle}>
                    <h3 style={headingStyle}>
                      4. Disclaimer of Warranties
                    </h3>

                    <p style={paragraphStyle}>
                      This website is provided "as is" without warranties of any
                      kind.
                    </p>
                  </div>

                  {/* Section 5 */}
                  <div style={sectionStyle}>
                    <h3 style={headingStyle}>
                      5. Limitation of Liability
                    </h3>

                    <p style={paragraphStyle}>
                      We will not be liable for any damages resulting from the
                      use of this website.
                    </p>
                  </div>

                  {/* Section 6 */}
                  <div style={sectionStyle}>
                    <h3 style={headingStyle}>
                      6. Indemnification
                    </h3>

                    <p style={paragraphStyle}>
                      You agree to indemnify us against any claims arising from
                      your use of the website.
                    </p>
                  </div>

                  {/* Section 7 */}
                  <div style={sectionStyle}>
                    <h3 style={headingStyle}>
                      7. Governing Law
                    </h3>

                    <p style={paragraphStyle}>
                      These terms are governed by the laws of India.
                    </p>
                  </div>

                  {/* Section 8 */}
                  <div
                    style={{
                      marginBottom: '5px',
                      paddingBottom: '5px',
                    }}
                  >
                    <h3 style={headingStyle}>
                      8. Changes to These Terms
                    </h3>

                    <p style={paragraphStyle}>
                      We reserve the right to modify these terms at any time.
                    </p>
                  </div>
                </Card.Body>
              </Card>
            </Col>
          </Row>

          {/* Payment Terms Heading */}
          <Row
            style={{
              marginTop: '55px',
              marginBottom: '25px',
            }}
          >
            <Col md={10} lg={9} className="mx-auto">
              <div
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: '14px',
                }}
              >
                <div
                  style={{
                    width: '46px',
                    height: '46px',
                    borderRadius: '12px',
                    background: '#eaf8f0',
                    color: '#198754',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    fontSize: '19px',
                    fontWeight: '800',
                    flexShrink: 0,
                  }}
                >
                  02
                </div>

                <div>
                  <h2
                    style={{
                      margin: 0,
                      fontSize: '26px',
                      fontWeight: '750',
                      color: '#172033',
                    }}
                  >
                    Payment Related Terms & Conditions
                  </h2>

                  <p
                    style={{
                      margin: '5px 0 0',
                      fontSize: '14px',
                      color: '#98a2b3',
                    }}
                  >
                    Terms related to online mock test services
                  </p>
                </div>
              </div>
            </Col>
          </Row>

          {/* Payment Terms Card */}
          <Row>
            <Col md={10} lg={9} className="mx-auto">
              <Card
                style={{
                  border: 'none',
                  borderRadius: '18px',
                  boxShadow: '0 12px 40px rgba(16, 24, 40, 0.08)',
                  overflow: 'hidden',
                }}
              >
                <Card.Body
                  style={{
                    padding: 'clamp(25px, 5vw, 50px)',
                  }}
                >
                  {/* Payment Section 1 */}
                  <div style={sectionStyle}>
                    <h3 style={headingStyle}>
                      Validity of Online Mock Test Series
                    </h3>

                    <p style={paragraphStyle}>
                      Access to the mock tests is valid for one year from
                      enrollment.
                    </p>
                  </div>

                  {/* Payment Section 2 */}
                  <div style={sectionStyle}>
                    <h3 style={headingStyle}>
                      Refund Policy
                    </h3>

                    <p style={paragraphStyle}>
                      Refunds are only provided for technical issues preventing
                      access.
                    </p>
                  </div>

                  {/* Payment Section 3 */}
                  <div style={sectionStyle}>
                    <h3 style={headingStyle}>
                      Modifications to Test Series
                    </h3>

                    <p style={paragraphStyle}>
                      We reserve the right to modify the test content at any
                      time.
                    </p>
                  </div>

                  {/* Payment Section 4 */}
                  <div
                    style={{
                      marginBottom: 0,
                    }}
                  >
                    <h3 style={headingStyle}>
                      Termination of Access
                    </h3>

                    <p style={paragraphStyle}>
                      Access may be terminated for policy violations or
                      fraudulent activity.
                    </p>
                  </div>
                </Card.Body>
              </Card>
            </Col>
          </Row>

          {/* Bottom Notice */}
          <Row
            style={{
              marginTop: '30px',
            }}
          >
            <Col md={10} lg={9} className="mx-auto">
              <div
                style={{
                  background: '#ffffff',
                  border: '1px solid #e8ecf2',
                  borderRadius: '14px',
                  padding: '18px 22px',
                  textAlign: 'center',
                  color: '#667085',
                  fontSize: '14px',
                  boxShadow: '0 5px 20px rgba(16, 24, 40, 0.04)',
                }}
              >
                Please review all terms and conditions carefully before using
                our services.
              </div>
            </Col>
          </Row>
        </Container>

        <Footer className="pt-0" />
      </div>
    );
  }
}

export default TermsAndConditions;